/**
 * Feature flags registry.
 * Add new feature flag keys here to make them available in the testing panel.
 *
 * @example
 * export const FEATURE_FLAGS = {
 *   newDashboard: { label: 'New Dashboard', description: 'Enable the new dashboard layout' },
 *   betaFilters: { label: 'Beta Filters', description: 'Enable experimental filter UI' },
 * } satisfies Record<string, FeatureFlagDefinition>
 */

export type FeatureFlagDefinition = {
  /** Display label for the testing panel UI */
  label: string
  /** Optional description shown as a tooltip or subtitle */
  description?: string
}

/**
 * Centralized registry of all feature flags.
 * Keys are used as identifiers in `useFeatureFlag`.
 *
 * Add your feature flags here.
 * The key is used in `useFeatureFlag('myFlag')` across the codebase.
 */
export const FEATURE_FLAGS = {
  storybookBanner: {
    label: 'Story — Beta Banner',
    description: 'Shows a beta announcement banner on the demo application page',
  },
  referentialMocks: {
    label: 'Mocked data — TVM → BO pages',
    description:
      'Serves fixtures for the pages migrated from TVM (the backend does not have their endpoints yet) and adds their permissions. Reload the page after toggling. Other pages still call the real backend; edits are lost on reload.',
  },
  // Add feature flags here, for example:
  // newDashboard: { label: 'New Dashboard', description: 'Enable the new dashboard layout' },
  // betaFilters: { label: 'Beta Filters', description: 'Enable experimental filter UI' },
} satisfies Record<string, FeatureFlagDefinition>

/** Union type of all valid feature flag keys */
export type FeatureFlagKey = keyof typeof FEATURE_FLAGS
